module.exports = __webpack_public_path__ + "assets/img/discernment_car_describe.6812fbdb.png";